import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';
import Fill from 'ol/style/Fill';
import Icon from 'ol/style/Icon';
import Circle from 'ol/style/Circle';
import RegularShape from 'ol/style/RegularShape';
import store from './../store';
let contextInstance = require('../api/ContextInstance.js').default;

('use strict');

const SELECT_COLOR = '#efd426';

export default class MapLayerStyleBuilder {
  constructor(apiStyle, layer, polesAnalysis) {
    this.style = apiStyle || {};
    this.layerType =
      layer.type === 'wfs' ? layer.basicGeometryType : layer.type;
    this.geometryMappings = {
      polygon: 'polygon',
      multipolygon: 'polygon',
      linestring: 'linestring',
      multilinestring: 'linestring',
      point: 'point',
      multipoint: 'point'
    };
    this.polesAnalysis = polesAnalysis;

    if (this.style && (!this.style.reguly || !this.style.reguly.length)) {
      this.setDefaultStyleRule();
    }

    this.layer = layer;
  }

  getStyle() {
    if (this.style) {
      let rules = this.style.reguly;

      if (rules && rules.length) {
        switch (this.style.typ) {
          case 'pojedynczy':
            return this.getSingleStyle(rules);
          case 'unikalny':
            return this.getUniqueStyle(rules);
          case 'stopniowy':
            return this.getGradualStyle(rules);
        }
      }
    }

    return undefined;
  }

  getMVTStyle() {
    let style = this.style;
    if (style.reguly && style.reguly.length) {
      if (style.reguly[0].sygnatura) {
        return this.getOlStyle(style.reguly[0].sygnatura);
      }
    } else {
      this.setDefaultStyleRule()
      return this.getMVTStyle()
    }
  }

  getSingleStyle(rules) {
    const self = this;

    let styles = {};
    let selectStyles = {};

    rules.forEach(x => {
      let geometry = x.geometria || self.layerType;

      if (!styles[geometry]) {
        styles[geometry] = {};
      }

      styles[geometry] = self.getOlStyle(x.sygnatura);
      selectStyles[geometry] = self.getOlSelectStyle(x.sygnatura, geometry);
    });

    return function(feature) {
      let geometry =
        self.geometryMappings[
          feature
            .getGeometry()
            .getType()
            .toLowerCase()
        ];
      let featureId = feature.get('element_uuid');

      let isDeleted = store.getters.removedFeatures.has(featureId);

      if (
        isDeleted ||
        !(
          contextInstance.hasPermission('View_all_infrastructure_data') ||
          (feature.get('organizacja') == contextInstance.state.organizationId &&
            contextInstance.hasPermission('View_own_infrastructure_data'))
        )
      ) {
        return null;
      }

      if (
        store.getters.editSession &&
        // false
        // &&
        store.getters.editSessionMapLayer &&
        store.getters.editSessionMapLayer.getSource().getFeatureById(featureId)
      ) {
        return null;
      }

      if (store.getters.selectedMapFeatures.has(featureId)) {
        return selectStyles[geometry];
      }

      if (
        self.polesAnalysis &&
        feature.get('z_1_ii_4') == 'c' &&
        // && (feature.get("z_1_ii_5") == "d03" || feature.get("z_1_ii_5") == "c01")
        // Testowo
        (feature.get('z_1_ii_5') == 'c06' ||
          feature.get('z_1_ii_5') == 'c04') &&
        feature.get('z_1_ii_6') == 'a'
      ) {
        return selectStyles[geometry];
      }

      return styles[geometry];
    };
  }

  getUniqueStyle(rules) {
    const self = this;

    let styles = {};
    let selectStyles = {};
    let attributes = {};

    rules.forEach(x => {
      let geometry = x.geometria || self.layerType;

      if (!styles[geometry]) {
        styles[geometry] = {};
        selectStyles[geometry] = {};
        attributes[geometry] = x.filtr.atrybut;
      }

      styles[geometry][x.filtr.wartosc] = self.getOlStyle(x.sygnatura);
      selectStyles[geometry][x.filtr.wartosc] = self.getOlSelectStyle(
        x.sygnatura,
        geometry
      );
    });

    return function(feature) {
      let geometry =
        self.geometryMappings[
          feature
            .getGeometry()
            .getType()
            .toLowerCase()
        ];
      let attribute = attributes[geometry];
      let value = feature.get(attribute);
      let featureId = feature.get('element_uuid');

      if (featureId) {
        let isDeleted = store.getters.removedFeatures.has(featureId);

        if (
          isDeleted ||
          !(
            contextInstance.hasPermission('View_all_infrastructure_data') ||
            (feature.get('organizacja') ==
              contextInstance.state.organizationId &&
              contextInstance.hasPermission('View_own_infrastructure_data'))
          )
        ) {
          return null;
        }

        if (
          store.getters.editSession &&
          store.getters.editSessionMapLayer
            .getSource()
            .getFeatureById(featureId)
        ) {
          return null;
        }

        if (store.getters.selectedMapFeatures.has(featureId)) {
          return selectStyles[geometry];
        }
      }

      return styles[geometry][value];
    };
  }

  getGradualStyle(rules) {
    const self = this;

    let styles = {};
    let selectStyles = {};
    let attributes = {};
    let functions = {
      '<=': (rule, value) => value <= rule.filtr.wartoscMin,
      '..': (rule, value) =>
        value > rule.filtr.wartoscMin && value <= rule.filtr.wartoscMax,
      '>=': (rule, value) =>
        value > rule.filtr.wartoscMin && value <= rule.filtr.wartoscMax
    };

    rules.forEach(x => {
      let geometry = x.geometria || self.layerType;

      if (!styles[geometry]) {
        styles[geometry] = {};
        selectStyles[geometry] = {};
        attributes[geometry] = x.filtr.atrybut;
      }

      let key = x.filtr.wartoscMin + '' + x.filtr.wartoscMax;

      styles[geometry][key] = self.getOlStyle(x.sygnatura);
      selectStyles[geometry][key] = self.getOlSelectStyle(
        x.sygnatura,
        geometry
      );
    });

    return function(feature) {
      let geometry =
        self.geometryMappings[
          feature
            .getGeometry()
            .getType()
            .toLowerCase()
        ];
      let attribute = attributes[geometry];
      let value = feature.get(attribute);

      let key = '';
      for (let i = 0; i < rules.length; ++i) {
        let rule = rules[i];

        if (functions[rule.filtr.operator](rule, value)) {
          key = rule.filtr.wartoscMin + '' + rule.filtr.wartoscMax;
          break;
        }
      }

      let featureId = feature.get('element_uuid');
      if (featureId) {
        let isDeleted = store.getters.removedFeatures.has(featureId);

        if (
          isDeleted ||
          !(
            contextInstance.hasPermission('View_all_infrastructure_data') ||
            (feature.get('organizacja') ==
              contextInstance.state.organizationId &&
              contextInstance.hasPermission('View_own_infrastructure_data'))
          )
        ) {
          return null;
        }

        if (
          store.getters.editSession &&
          store.getters.editSessionMapLayer
            .getSource()
            .getFeatureById(featureId)
        ) {
          return null;
        }

        if (store.getters.selectedMapFeatures.has(featureId)) {
          return selectStyles[geometry];
        }
      }

      return styles[geometry][key];
    };
  }

  getOlStyle(signature) {
    //special case for linestring
    if (
      signature.wypelnienie.szerokosc &&
      signature.wypelnienie.szerokosc < signature.obrys.szerokosc
    ) {
      return [
        new Style({
          stroke: new Stroke({
            color: this.getColor(signature.obrys.kolor),
            lineDash: this.getDash(
              signature.obrys.szerokosc,
              signature.obrys.kreskowanie
            ),
            width: signature.obrys.szerokosc
          })
        }),
        new Style({
          stroke: new Stroke({
            color: this.getColor(signature.wypelnienie.kolor),
            lineDash: this.getDash(
              signature.wypelnienie.szerokosc,
              signature.wypelnienie.kreskowanie
            ),
            width: signature.wypelnienie.szerokosc
          })
        })
      ];
    }

    let stroke = new Stroke({
      color: this.getColor(signature.obrys.kolor),
      lineDash: this.getDash(
        signature.obrys.szerokosc,
        signature.obrys.kreskowanie
      ),
      width: signature.obrys.szerokosc
    });

    let fill = new Fill({
      color: this.getColor(signature.wypelnienie.kolor)
    });

    return new Style({
      fill: fill,
      stroke: stroke,
      image: this.getImage(signature, fill, stroke)
    });
  }

  getOlSelectStyle(signature, type) {
    var strokeColor = SELECT_COLOR;
    var fillColor = this.getColor(signature.wypelnienie.kolor);

    let stroke = new Stroke({
      color: strokeColor,
      lineDash: this.getDash(
        signature.obrys.szerokosc * 1.25,
        signature.obrys.kreskowanie
      ),
      width: signature.obrys.szerokosc * 1.25
    });

    let fill = new Fill({
      color: fillColor
    });

    return new Style({
      fill: fill,
      stroke: stroke,
      image: this.getImage(signature, fill, stroke, true)
    });
  }

  getImage(signature, fill, stroke, isSelect) {
    let point = signature.punkt;

    if (!point) {
      return null;
    }

    if (point.ikona) {
      if (isSelect) {
        let img = this.createHighlightedImage(point.ikona, point.rozmiar);
        return this.createIcon(point.rozmiar, undefined, img);
      }
      return this.createIcon(point.rozmiar, point.ikona, undefined);
    }

    switch (point.ksztalt) {
      case 'circle':
        return new Circle({
          fill: fill,
          stroke: stroke,
          radius: point.rozmiar
        });
      case 'square':
        return new RegularShape({
          fill: fill,
          stroke: stroke,
          radius: point.rozmiar,
          points: 4,
          angle: Math.PI / 4
        });
      case 'triangle':
        return new RegularShape({
          fill: fill,
          stroke: stroke,
          radius: point.rozmiar,
          points: 3,
          rotation: Math.PI / 4,
          angle: 0
        });
      case 'star':
        return new RegularShape({
          fill: fill,
          stroke: stroke,
          radius: point.rozmiar,
          points: 5,
          radius2: 4,
          angle: 0
        });
      case 'cross':
        return new RegularShape({
          fill: fill,
          stroke: stroke,
          radius: point.rozmiar,
          points: 4,
          radius2: 0,
          angle: 0
        });
    }
  }

  getColor(styleColor) {
    if (styleColor === Object(styleColor)) {
      return [styleColor.r, styleColor.g, styleColor.b, styleColor.a];
    } else {
      return styleColor;
    }
  }

  setDefaultStyleRule() {
    this.style.typ = 'pojedynczy';
    let geometryType = this.geometryMappings[this.layerType];

    var defaultRule;

    if (geometryType === 'polygon') {
      defaultRule = {
        sygnatura: {
          obrys: {
            kolor: { r: 0, g: 153, b: 255, a: 1 },
            szerokosc: 1
          },
          wypelnienie: {
            kolor: { r: 255, g: 255, b: 255, a: 0.5 }
          }
        }
      };
    } else if (geometryType === 'linestring') {
      defaultRule = {
        sygnatura: {
          obrys: {
            kolor: { r: 0, g: 153, b: 255, a: 1 },
            szerokosc: 1
          },
          wypelnienie: {}
        }
      };
    } else if (geometryType === 'point') {
      defaultRule = {
        sygnatura: {
          obrys: {
            kolor: '#3399CC',
            szerokosc: 1.25
          },
          wypelnienie: {
            kolor: { r: 255, g: 255, b: 255, a: 0.4 }
          },
          punkt: {
            ksztalt: 'circle',
            rozmiar: 5
          }
        }
      };
    }

    if (defaultRule) {
      defaultRule.geometria = this.layerType;
      this.style.reguly = [defaultRule];
    }
  }

  createHighlightedImage(pngBase64, size) {
    let image = this.loadImage(pngBase64, size);
    image.crossOrigin = '*'; // Set cross-origin attribute
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    var dArr = [-1, -1, 0, -1, 1, -1, -1, 0, 1, 0, -1, 1, 0, 1, 1, 1],
      s = 4,
      i = 0,
      x = 4,
      y = 4;
    canvas.width = image.width + s + s;
    canvas.height = image.height + s + s;

    for (; i < dArr.length; i += 2) {
      ctx.drawImage(image, x + dArr[i] * s, y + dArr[i + 1] * s);
    }

    ctx.globalCompositeOperation = 'source-in';
    ctx.fillStyle = SELECT_COLOR;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.globalCompositeOperation = 'source-over';
    ctx.drawImage(image, x, y, image.width, image.height);
    return canvas;
  }

  loadImage(pngBase64, size) {
    function base64ToUint8Array(base64, type) {
      var byteString = atob(base64.split(',')[1]);
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return ia;
    }

    var UPNG = require('upng-js');
    var upng = UPNG.decode(base64ToUint8Array(pngBase64));

    if (upng && upng.data) {
      let upngWidth = upng.width;
      let upngHeight = upng.height;
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      var image = new Image(upngWidth, upngHeight);
      image.crossOrigin = '*'; // Set cross-origin attribute
      canvas.width = image.width;
      canvas.height = image.height;
      context.drawImage(image, 0, 0, upngWidth, upngHeight);
      var imageData = context.getImageData(0, 0, canvas.width, canvas.height);
      var data = imageData.data;
      for (var i = 0; i < data.length; i += 1) {
        data[i] = upng.data[i];
      }
      context.putImageData(imageData, 0, 0);
      return canvas;
    }
  }

  createIcon(size, src, img) {
    return new Icon({
      scale: size / 150,
      crossOrigin: '*',
      src: src,
      img: img,
      imgSize: img ? [img.width, img.height] : undefined
    });
  }

  getDash(size, style) {
    if (style != null && style instanceof Array) {
      if (style.length === 1) {
        return style;
      } else if (style[0] === 1) {
        return [size, size];
      } else {
        return [size, 2 * size];
      }
    }
    return style;
  }
}
